"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  z50: "#FFFDF6",
  z100: "#FEFAEC",
  z200: "#FCEEC0",
  z300: "#FCDF82",
  z400: "#F8D149",
  z500: "#F3C117",
  z600: "#E9B501",
  z700: "#DC9D09",
  z800: "#A16E17",
  z900: "#6B4900"
};
exports["default"] = _default;